import { Space } from 'antd';
import styled from 'styled-components';

export const BlockSpace = styled(Space)`
  width: 100%;
`;
